var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.onClickOutSite,
      expression: "onClickOutSite"
    }],
    ref: "selectWrap",
    staticClass: "relative"
  }, [_vm._t("input-wrap", function () {
    return [!_vm.hiddenInput ? _c('div', {
      staticClass: "w-full border min-h-[42.39px] rounded-[8px] p-2 inline-flex items-center bg-[#F3F4F6] form-control",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.toggleShowMenu.apply(null, arguments);
        }
      }
    }, [!_vm.dropdownValue || _vm.multiple && !_vm.dropdownValue.length ? _c('p', {
      staticClass: "text-[#797979]"
    }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _c('div', {
      staticClass: "flex flex-row gap-2 flex-1 items-center flex-wrap"
    }, [_vm.multiple ? _c('fragment', _vm._l(_vm.dropdownValue, function (val, valIndex) {
      return _c('div', {
        key: valIndex,
        staticClass: "border border-gray-300 px-1 rounded justify-center min-w-[60px]"
      }, [_c('span', {
        class: [{
          'w-[60px] inline-block': !_vm.getValueLabel(val)
        }]
      }, [_vm._v(_vm._s(_vm.getValueLabel(val)))]), _c('i', {
        staticClass: "fa-solid fa-xmark text-sm ml-2 text-gray-400",
        on: {
          "click": function ($event) {
            $event.stopPropagation();
            return _vm.handleRemoveItem(val);
          }
        }
      })]);
    }), 0) : _c('span', [_vm._v(" " + _vm._s(_vm.getValueLabel(_vm.dropdownValue)) + " ")])], 1), _c('div', {
      staticClass: "space-x-2"
    }, [_vm.showClearButton ? _c('i', {
      staticClass: "fa-solid fa-xmark text-sm ml-2 text-gray-400",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.handleRemoveAllItem.apply(null, arguments);
        }
      }
    }) : _vm._e(), !_vm.alwaysShowMenu ? _c('i', {
      staticClass: "fa-solid fa-chevron-down ml-2 text-gray-400",
      class: [_vm.showMenu ? 'fa-chevron-up' : 'fa-chevron-down'],
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.toggleShowMenu.apply(null, arguments);
        }
      }
    }) : _vm._e()])]) : _vm._e()];
  }, {
    "data": {
      dropdownValue: _vm.dropdownValue,
      toggleShowMenu: _vm.toggleShowMenu
    }
  }), _vm.showMenu ? _c('div', {
    ref: "menuRef",
    staticClass: "rounded-bl rounded-br border mt-[1px] p-2 bg-white z-10",
    class: _vm.absoluteClass ? 'absolute' : ''
  }, [_vm.searchable ? _c('div', {
    staticClass: "relative h-[38px]"
  }, [_c('div', {
    staticClass: "absolute left-2 top-2 pr-2 border-r"
  }, [_vm.loading ? _c('i', {
    staticClass: "fa-solid fa-spin fa-circle-notch"
  }) : _c('i', {
    staticClass: "fa-solid fa-magnifying-glass"
  })]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.keyword,
      expression: "keyword"
    }],
    ref: "inputSearch",
    staticClass: "border w-full h-full rounded bg-gray-50 pl-[45px]",
    domProps: {
      "value": _vm.keyword
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.keyword = $event.target.value;
      }
    }
  })]) : _vm._e(), _c('ul', {
    staticClass: "mt-2 overflow-x-hidden overflow-y-auto",
    class: [_vm.alwaysShowMenu ? 'h-[500px]' : {
      'h-[200px]': _vm.filteredOptions.length
    }],
    on: {
      "scroll": _vm.onscroll
    }
  }, [_vm.filteredOptions.length ? _c('fragment', [_vm._t("option-content", function () {
    return _vm._l(_vm.filteredOptions, function (op, opIndex) {
      return _c('li', {
        key: opIndex,
        staticClass: "p-[1px] hover:bg-blue-200 cursor-pointer",
        class: [{
          'bg-blue-50 font-semibold hover:bg-red-300': _vm.checkItemIsSelected(op.id)
        }],
        on: {
          "click": function ($event) {
            return _vm.handleClickOptionItem(op);
          }
        }
      }, [_vm._v(" " + _vm._s(op.text) + " ")]);
    });
  }, {
    "data": {
      optionsData: _vm.filteredOptions,
      handleClickOptionItem: _vm.handleClickOptionItem,
      checkItemIsSelected: _vm.checkItemIsSelected
    }
  })], 2) : _vm.loading ? _c('li', {
    staticClass: "p-[1px] cursor-pointer"
  }, [_vm._v(_vm._s(_vm.loadingText))]) : _c('li', {
    staticClass: "p-[1px] cursor-pointer"
  }, [_vm._v(_vm._s(_vm.emptyOptionText))])], 1)]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }